<template>
    <div>
        <vapp-header btnContactPersonOptions btnClose :contact_person_id="contactBeingEdited.id"></vapp-header>
        <div class="container pr-5 pb-5 pl-5 pt-2 d-flex flex-column">
            <div class="switch">
              <md-switch v-model="customer">Customer</md-switch>
              <md-switch v-model="supplier">Supplier</md-switch>
            </div>
            <form class="w-100 form-fnc" autocomplete="off">

                <div role="tablist" class="contact-accordion tablist-contact ">

                    <div class="border-bottom-10">
                    </div>

                    <b-card no-body class="mb-1">
                        <b-card-header header-tag="header" role="tab">
                            <b-btn href="#" block v-b-toggle.contactperson>
                                <img src="@/assets/images/ct-user-solid.svg" />
                                Contact Person
                                <img class="float-right" src="@/assets/images/angle-down-solid.svg" /></b-btn>
                        </b-card-header>

                        <b-collapse id="contactperson" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>

                                <label>First Name <span class="mandatory-remarks">*</span></label>
                                <div class="input-group">
                                    <input type="text" class="form-control padding-override" placeholder="John" v-model="first_name"
                                           v-bind:class="{ 'is-invalid': attemptSubmit && missingFirstName }" v-on:input="updateDisplayName">
                                    <div class="invalid-feedback" v-for="error in errors" v-if="error.id == 'first_name'">{{ error.text }}</div>
                                </div>

                                <label>Last Name</label>
                                <div class="input-group">
                                    <input type="text" class="form-control padding-override" placeholder="Cena" v-model="last_name" v-on:input="updateDisplayName">
                                </div>

                                <label>Display name <span class="mandatory-remarks">*</span></label>
                                <div class="input-group">
                                    <input type="text" class="form-control padding-override" placeholder="john117" v-model="display_name"
                                           v-bind:class="{ 'is-invalid': attemptSubmit && missingDisplayName }">
                                    <div class="invalid-feedback" v-for="error in errors" v-if="error.id == 'display_name'">{{ error.text }}</div>
                                </div>

                                <label>Email</label>
                                <div class="input-group">
                                    <input type="email" class="form-control padding-override" placeholder="john@unsc.gov" v-model="email"
                                           v-bind:class="{ 'is-invalid': attemptSubmit && invalidEmailFormat }">
                                    <div class="invalid-feedback" v-for="error in errors" v-if="error.id == 'email'">{{ error.text }}</div>
                                </div>

                                <label>Phone Number</label>
                                <div class="input-group">
                                    <input type="number" class="form-control padding-override" placeholder="Please enter a valid number" v-model="phone_no">
                                </div>

                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: "EditPerson",
        data() {
            return {
                //Person
                display_name: null,
                first_name: null,
                last_name: null,
                email: null,
                phone_no: null,
                customer: false,
                supplier: false,

                //Others
                attemptSubmit: false,
                errors: [],
            }
        },
        computed: {
            ...mapState('contact', ['contactBeingEdited']),
            missingDisplayName: function () {
                if (!this.display_name) { return true; } else { return false; }
            },
            missingFirstName: function () {
                if (!this.first_name) { return true; } else { return false; }
            },
            missingLastName: function () {
                if (!this.last_name) { return true; } else { return false; }
            },
            missingEmail: function () {
                if (!this.email) { return true; } else { return false; }
            },
            invalidEmailFormat: function () {
                if (this.email) { if (!this.validEmail(this.email)) { return true; } else { return false; } }
            },
            missingPhoneNo: function () {
                if (!this.phone_no) { return true; } else { return false; }
            },
            requestData: function() {
                return {
                    is_customer: this.customer,
                    is_supplier: this.supplier,
                    memo: null,
                    currency_id: null,
                    method_id: null,
                    term_id: null,
                    supplier_currency_id: null,
                    supplier_method_id: null,
                    supplier_term_id: null,
                    entity: {
                        display_name: this.display_name,
                        email: this.email,
                        phone_no: this.phone_no,
                        first_name: this.first_name,
                        last_name: this.last_name,
                    },
                    send_mail: true,
                    files: [null],
                    extras: [],
                }
            }
        },
        mounted() {
            console.log("Mounted : EditPerson");
            // set person data [PENDING FROM API]
            this.display_name = this.contactBeingEdited.entity.first_name + " " + this.contactBeingEdited.entity.last_name
            this.first_name = this.contactBeingEdited.entity.first_name
            this.last_name = this.contactBeingEdited.entity.last_name
            this.email = this.contactBeingEdited.entity.email
            this.phone_no = this.contactBeingEdited.entity.phone_no
            this.supplier = this.contactBeingEdited.is_supplier;
            this.customer = this.contactBeingEdited.is_customer;
            // Will get call when user click on done button top right
            // Do checking for compulsory fields first, then pop up confirmation dialog
            this.$root.$on('attempt_submit_edit_person', vars => {
                this.errors = [];
                this.attemptSubmit = true;

                if (this.missingDisplayName) {
                    this.errors.push({id: 'display_name', text: "This field is compulsory"});
                }

                if (this.missingFirstName) {
                    this.errors.push({id: 'first_name', text: "This field is compulsory"});
                }

                if (!this.missingEmail && this.invalidEmailFormat) {
                    this.errors.push({id: 'email', text: 'Valid email required.'});
                }

                if(!this.errors.length) {
                    event.preventDefault();
                    this.$confirmationToast("Edit Person?", "Are you sure you want to edit this person?", this.editPersonDraft, null);
                } else {
                    event.preventDefault();
                }

            })

            this.setDisplayName(this.first_name, this.last_name);
        },
        beforeDestroy () {
            this.$root.$off('attempt_submit_edit_person')
        },
        methods: {
            setDisplayName (firstName, lastName) {
                this.display_name = '';
                if (firstName) {
                    this.display_name += firstName;
                }
                if (lastName) {
                    this.display_name += lastName;
                }
            },
            validEmail: function(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            goBack() {
                window.history.length > 1 ?
                    this.$router.go(-1) :
                    this.$router.push('/login')
            },
            editPersonDraft() {
                this.$root.$emit('show-loading', true);
                this.axios({
                    method: 'put',
                    url: '/contacts/peoples/' + this.contactBeingEdited.id,
                    data: this.requestData,
                }).then(response => {
                    this.$root.$emit('show-loading', false);
                    this.goBack()
                }).catch(error => {
                    this.$root.$emit('show-loading', false);
                    this.$generalAPIErrorHandling(error, this.$router);
                })
            },
            updateDisplayName() {
                this.display_name = this.first_name + " " + this.last_name;
            }
        },
    }
</script>
